export default {"src":"/_next/static/media/bed-queen.958c9ed8.svg","height":23,"width":25,"blurWidth":0,"blurHeight":0};